export default __webpack_public_path__ + "static/media/total_registered.a7c2b587.svg";